export default __webpack_public_path__ + "static/media/Product-Stock.fc29860a.jpg";